import { Component } from '@angular/core';
import { NavController, NavParams, AlertController, ViewController, ToastController } from 'ionic-angular';
import { AngularFirestore } from 'angularfire2/firestore';
import { LoadingProvider } from '../../providers/loading/loading';
import { AddLoanAdminPage } from '../add-loan-admin/add-loan-admin';
import firebase from 'firebase/app';
import { Http, RequestOptions, Headers } from '@angular/http';
import {EnvDataService} from '../../app/services/env-data-service';
@Component({
  selector: 'page-loan-admin',
  templateUrl: 'loan-admin.html',
  providers:[EnvDataService]
})
export class LoanAdminPage {

  public email: any;
  public uid: any;
  public firstname: any;
  public lastname: any;
  public getRole: any;
  public usersList : any = [];
  data: any = [];
  public deleted_access : any
  public userRole: any;

  constructor(
    public navCtrl: NavController, 
    public db: AngularFirestore,
    public navParams: NavParams,
    public loadingProvider: LoadingProvider,
    public alertCtrl: AlertController,
    public toastCtrl: ToastController,
    public viewCtrl: ViewController,
    public http: Http,
    private EnvDataService:EnvDataService
  ) {

    this.deleted_access = window.localStorage.getItem("deleted_access");
    this.userRole = window.localStorage.getItem("userRole");
  }

  getAllLoanAdmins (){
    if(this.deleted_access > 0){
      return this.db.collection<any>( "users" , ref => ref.where('roles.loan_admin','==',true )).valueChanges ();
    }else{
      return this.db.collection<any>( "users" , ref => ref.where('roles.loan_admin','==',true ).where('deleted','<',1 )).valueChanges ();
    }
    
  }

  addLoanAdmin(event){
    this.navCtrl.push(AddLoanAdminPage);
  }

  stringGen(len) {
    var text = "";
    var charset = "abcdefghijklmnopqrstuvwxyz0123456789";
    for (var i = 0; i < len; i++)
      text += charset.charAt(Math.floor(Math.random() * charset.length));
    return text;
  }

  ionViewDidLoad() {

  }

  ngOnInit(){
    //console.log('ionViewDidLoad BrokersPage');
    this.email = window.localStorage.getItem("email");
    this.uid = window.localStorage.getItem("uid");

    this.getAllLoanAdmins().subscribe((data)=>{
      for(let i = 0; i < data.length; i++) {
        data[i].broker_name = [];
        if(data[i].assigned_broker.length > 0){
          for(let j = 0; j < data[i].assigned_broker.length; j++) {
            var docRef1 = firebase.firestore().collection("users").doc(data[i].assigned_broker[j]);
            docRef1.get().then(function(doc) {
              if (doc.exists) {
                data[i].broker_name[j] = doc.data().firstname+' '+doc.data().lastname;
              } else {
                console.log("No such document!");
              }
            }).catch(function(error) {
              console.log("Error getting document:", error);
            });
          }
        }        
      }
      this.data = data;
    });
  }

  editLoanAdmin(event, contact_uid){
    this.navCtrl.push(AddLoanAdminPage,{
      edit_contact_uid:contact_uid
      });
  }

  deleteLoanAdmin(event, contact_uid){
    let alert = this.alertCtrl.create({
      title: 'Confirm delete Loan admin',
      message: 'Are you sure you want to delete this Loan admin?',
      buttons: [
          {
              text: 'No',
              handler: () => {
                  console.log('Cancel clicked');
              }
          },
          {
              text: 'Yes',
              handler: () => {
                if(contact_uid !=""){
                  this.loadingProvider.startLoading();
                  var headers = new Headers();
                  headers.append("Accept", 'application/json');
                  headers.append('Content-Type', 'application/json' );
                  const requestOptions = new RequestOptions({ headers: headers });
                  let postData = {
                    'contact_uid' : contact_uid,
                    'deleted_date' : new Date().getTime()
                  }
                  var url = this.EnvDataService.EnvData.sendbox_api+"/deleteLoanAdmin";
                  this.http.post(url, postData, requestOptions)
                  .subscribe(data => {
                    if(data['_body'] == 'success'){
                      this.presentToast('Deleted successfully.');
                      this.loadingProvider.stopLoading();
                    }else{
                      this.presentToast('Something went wrong please try again later.');
                      this.loadingProvider.stopLoading();
                    }
                  }, error => {
                    this.presentToast(error.message);      
                  });
                }
              }
          }
      ]
    });
    alert.present();
  }


  restoreLoanAdmin(index: number, contact_uid: any) {
    let alert = this.alertCtrl.create({
      title: 'Confirm restore Loan Admin',
      message: 'Are you sure you want to restore this  Loan Admin?',
      buttons: [
          {
              text: 'No',
              handler: () => {
                  console.log('Cancel clicked');
              }
          },
          {
              text: 'Yes',
              handler: () => {
                if(contact_uid !=""){
                  this.loadingProvider.startLoading();
                  var headers = new Headers();
                  headers.append("Accept", 'application/json');
                  headers.append('Content-Type', 'application/json' );
                  const requestOptions = new RequestOptions({ headers: headers });
                  let postData = {
                    'contact_uid' : contact_uid
                  }
                  var url = this.EnvDataService.EnvData.sendbox_api+"/restoreLoanAdmin";
                  this.http.post(url, postData, requestOptions)
                  .subscribe(data => {
                    if(data['_body'] == 'success'){
                      this.presentToast('Restore successfully.');
                      this.loadingProvider.stopLoading();
                    }else{
                      this.presentToast('Something went wrong please try again later.');
                      this.loadingProvider.stopLoading();
                    }
                  }, error => {
                    this.presentToast(error.message);      
                  });
                }                
              }
          }
      ]
    });
    alert.present();
  }

  presentToast(err) {
    const toast = this.toastCtrl.create({
      message: err,
      duration: 3000,
      position: 'bottom'
    });

    toast.present();
  }

}



// WEBPACK FOOTER //
// ./src/pages/loan-admin/loan-admin.ts